import apiFarms from "../config/api_farms";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFarms = axios.create({
//   baseURL: "http://localhost:8082",
// });

export function findFarmReadFeederTreatmentParameterData(payload) {
  const { groupId, farmId } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/read/feeder/parameters`,
    getHeaders(false, null)
  );
}

export function saveFarmReadFeederTreatmentParameterData(payload) {
  const { groupId, farmId, body } = payload;

  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/read/feeder/parameters`,
    body,
    getHeaders(false, null)
  );
}
